var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        size: "md",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "no-fade": "",
        "no-stacking": "",
        centered: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c("div", { staticClass: "my-auto" }, [
                _c(
                  "h2",
                  {
                    staticClass: "font-weight-normal",
                    attrs: {
                      "data-test-hook": "products-over-limit-modal-header"
                    }
                  },
                  [
                    _c("div", [
                      _c("i", {
                        staticClass: "far fa-warning colorOrange mr-1",
                        attrs: {
                          "data-test-hook":
                            "products-over-limit-modal-header-icon"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")) +
                          " "
                      )
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-icon-button--gray",
                      attrs: {
                        variant: "icon-button",
                        "data-test-hook": "x-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(_vm.modalId)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "secondary",
                    disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                      _vm.currentAppConfig
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.removeFromAccountButtonOnPress()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xRemoveFromAccount")) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.learnMoreButtonOnPress()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xLearnMoreLowercase")) + " ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", [
        _c("p", [
          _vm._v(" " + _vm._s(_vm.getBodyText1) + " "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.generac.com/dealer-locator/",
                target: "_blank"
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("xOverTheLimitModalBodyText2")) + " ")]
          ),
          _vm._v(" " + _vm._s(_vm.$t("xOverTheLimitModalBodyText3")) + " ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }